import type { RouteLocationRaw } from "vue-router";
import { $t } from "./src/utils/i18n";

export const USER_CENTER_BASE_PATH = "/user-center";

export interface UserCenterRouteDef {
  legacyPath: string;
  nuxtPath: string;
  name: string;
  viewKey: string;
  code?: string;
  title?: string;
  pageTitle?: string;
  requiresAuth?: boolean;
  standalone?: boolean;
  hiddenSider?: boolean;
  fullLayout?: boolean;
}

function createRoute(def: Omit<UserCenterRouteDef, "nuxtPath">): UserCenterRouteDef {
  return {
    ...def,
    nuxtPath: `${USER_CENTER_BASE_PATH}${def.legacyPath}`,
  };
}

export const userCenterRouteDefs: UserCenterRouteDef[] = [
  createRoute({
    legacyPath: "/login",
    name: "UserCenterLogin",
    viewKey: "login",
    title: $t("userCenter.titles.login"),
    pageTitle: $t("userCenter.titles.login"),
    requiresAuth: false,
    standalone: true,
  }),
  createRoute({
    legacyPath: "/mall/home",
    name: "mallHome",
    viewKey: "mallHome",
    code: "mallHome",
    title: $t("userCenter.titles.home"),
    pageTitle: $t("userCenter.titles.home"),
  }),
  createRoute({
    legacyPath: "/mall/mallCenterHome",
    name: "mallCetnerHome",
    viewKey: "mallHome1",
    code: "mallHome1",
    title: $t("userCenter.titles.home"),
    pageTitle: $t("userCenter.titles.home"),
  }),
  createRoute({
    legacyPath: "/mall/expertPurchaseHome",
    name: "mallExpertPurchaseHome",
    viewKey: "mallExpertPurchaseHome",
    code: "mallExpertPurchaseHome",
    title: $t("userCenter.titles.expertPurchase"),
    pageTitle: $t("userCenter.titles.expertPurchase"),
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/expertPurchaseOrders",
    name: "mallExpertPurchaseOrders",
    viewKey: "mallExpertPurchaseOrders",
    code: "mallExpertPurchaseOrders",
    title: $t("userCenter.titles.expertPurchaseOrders"),
    pageTitle: $t("userCenter.titles.expertPurchaseOrders"),
  }),
  createRoute({
    legacyPath: "/mall/platformAllOrderList",
    name: "mallAllOrderList",
    viewKey: "mallAllOrderList",
    code: "mallAllOrderList",
    title: $t("userCenter.titles.allOrders"),
    pageTitle: $t("userCenter.titles.allOrders"),
  }),
  createRoute({
    legacyPath: "/mall/platformAllOrderListV2",
    name: "mallAlibabaOrderListV2",
    viewKey: "mallAlibabaOrderListV2",
    code: "mallAlibabaOrderListV2",
    title: $t("userCenter.titles.myOrders"),
    pageTitle: $t("userCenter.titles.myOrders"),
  }),
  createRoute({
    legacyPath: "/mall/refundOrderList",
    name: "mallRefundOrderList",
    viewKey: "mallRefundOrderList",
    code: "mallRefundOrderList",
    title: $t("userCenter.titles.refundOrders"),
    pageTitle: $t("userCenter.titles.refundOrders"),
  }),
  createRoute({
    legacyPath: "/mall/selectOrderList",
    name: "mallSelectOrderList",
    viewKey: "mallSelectOrderList",
    code: "mallSelectOrderList",
    title: $t("userCenter.titles.allOrders"),
    pageTitle: $t("userCenter.titles.allOrders"),
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/warehousePackage",
    name: "mallWarehousePackage",
    viewKey: "mallWarehousePackage",
    code: "mallWarehousePackage",
    title: $t("userCenter.titles.warehousePackage"),
    pageTitle: $t("userCenter.titles.warehousePackage"),
  }),
  createRoute({
    legacyPath: "/mall/favorites",
    name: "mallFavorites",
    viewKey: "mallFavorites",
    code: "mallFavorites",
    title: $t("userCenter.titles.favorites"),
    pageTitle: $t("userCenter.titles.favorites"),
  }),
  createRoute({
    legacyPath: "/mall/browseHistory",
    name: "mallBrowseHistory",
    viewKey: "mallBrowseHistory",
    code: "mallBrowseHistory",
    title: $t("userCenter.titles.browseHistory"),
    pageTitle: $t("userCenter.titles.browseHistory"),
  }),
  createRoute({
    legacyPath: "/mall/account",
    name: "mallAccount",
    viewKey: "mallAccount",
    code: "mallAccount",
    title: $t("userCenter.titles.memberCenter"),
    pageTitle: $t("userCenter.titles.memberCenter"),
  }),
  createRoute({
    legacyPath: "/mall/message",
    name: "mallMessage",
    viewKey: "mallMessage",
    code: "mallMessage",
    title: $t("userCenter.titles.messageCenter"),
    pageTitle: $t("userCenter.titles.messageCenter"),
  }),
  createRoute({
    legacyPath: "/mall/notices",
    name: "mallNotices",
    viewKey: "mallNotices",
    code: "mallNotices",
    title: $t("userCenter.titles.mallNotices"),
    pageTitle: $t("userCenter.titles.mallNotices"),
  }),
  createRoute({
    legacyPath: "/mall/allOrderDetail",
    name: "mallAllOrderDetail",
    viewKey: "mallAllOrderDetail",
    code: "mallAllOrderDetail",
    title: $t("userCenter.titles.orderDetail"),
    pageTitle: $t("userCenter.titles.orderDetail"),
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/tbOrderDetail",
    name: "mallTbOrderDetail",
    viewKey: "mallTbOrderDetail",
    code: "mallTbOrderDetail",
    title: $t("userCenter.titles.orderDetail"),
    pageTitle: $t("userCenter.titles.orderDetail"),
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/weidianOrderDetail",
    name: "mallWeidianOrderDetail",
    viewKey: "mallWeidianOrderDetail",
    code: "mallWeidianOrderDetail",
    title: $t("userCenter.titles.orderDetail"),
    pageTitle: $t("userCenter.titles.orderDetail"),
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/unifiedOrderDetail",
    name: "mallUnifiedOrderDetail",
    viewKey: "mallUnifiedOrderDetail",
    code: "mallUnifiedOrderDetail",
    title: $t("userCenter.titles.orderDetail"),
    pageTitle: $t("userCenter.titles.orderDetail"),
  }),
  createRoute({
    legacyPath: "/mall/cart",
    name: "mallCart",
    viewKey: "mallCart",
    code: "mallCart",
    title: $t("userCenter.titles.shoppingCart"),
    pageTitle: $t("userCenter.titles.shoppingCart"),
  }),
  createRoute({
    legacyPath: "/mall/confirmation1688Order",
    name: "mallConfirmation1688Order",
    viewKey: "mallConfirmation1688Order",
    code: "mallConfirmation1688Order",
    title: $t("userCenter.titles.confirmOrder"),
    pageTitle: $t("userCenter.titles.confirmOrder"),
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/confirmationWeidianOrder",
    name: "mallConfirmationWeidianOrder",
    viewKey: "mallConfirmationWeidianOrder",
    code: "mallConfirmationWeidianOrder",
    title: $t("userCenter.titles.confirmOrder"),
    pageTitle: $t("userCenter.titles.confirmOrder"),
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/Pay1688Order",
    name: "mallPay1688Order",
    viewKey: "mallPay1688Order",
    code: "mallPay1688Order",
    title: $t("userCenter.titles.payOrder"),
    pageTitle: $t("userCenter.titles.payOrder"),
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/PayWeidianOrder",
    name: "mallPayWeidianOrder",
    viewKey: "mallPayWeidianOrder",
    code: "mallPayWeidianOrder",
    title: $t("userCenter.titles.payOrder"),
    pageTitle: $t("userCenter.titles.payOrder"),
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/tbDirectPaymentConfirm",
    name: "mallTbDirectPaymentConfirm",
    viewKey: "mallTbDirectPaymentConfirm",
    code: "mallTbDirectPaymentConfirm",
    title: $t("userCenter.titles.confirmOrder"),
    pageTitle: $t("userCenter.titles.confirmOrder"),
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/tbPayOrder",
    name: "mallTbPayOrder",
    viewKey: "mallTbPayOrder",
    code: "mallTbPayOrder",
    title: $t("userCenter.titles.payOrder"),
    pageTitle: $t("userCenter.titles.payOrder"),
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/recharge",
    name: "mall1688Recharge",
    viewKey: "mallRecharge",
    code: "mall1688Recharge",
    title: $t("userCenter.titles.balanceRecharge"),
    pageTitle: $t("userCenter.titles.balanceRecharge"),
  }),
  createRoute({
    legacyPath: "/mall/recharge/gold",
    name: "mallGoldRecharge",
    viewKey: "mallGoldRecharge",
    code: "mallGoldRecharge",
    title: $t("userCenter.titles.mallGoldRecharge"),
    pageTitle: $t("userCenter.titles.mallGoldRecharge"),
  }),
  createRoute({
    legacyPath: "/collection/mallPackage",
    name: "mallPackage",
    viewKey: "collectionMallPackage",
    code: "mallPackage",
    title: $t("userCenter.titles.mallPackage"),
    pageTitle: $t("userCenter.titles.mallPackage"),
  }),
  createRoute({
    legacyPath: "/collection/myWarehouse",
    name: "CollectionMyWarehouse",
    viewKey: "collectionMyWarehouse",
    code: "CollectionMyWarehouse",
    title: $t("userCenter.titles.myWarehouse"),
    pageTitle: $t("userCenter.titles.myWarehouse"),
  }),
  createRoute({
    legacyPath: "/collection/myPackage",
    name: "CollectionMyPackage",
    viewKey: "collectionMyPackage",
    code: "CollectionMyPackage",
    title: $t("userCenter.titles.myPackage"),
    pageTitle: $t("userCenter.titles.myPackage"),
  }),
  createRoute({
    legacyPath: "/collection/home",
    name: "CollectionHome",
    viewKey: "collectionHome",
    code: "collectionHome",
    title: $t("userCenter.titles.collectionHome"),
    pageTitle: $t("userCenter.titles.collectionHome"),
  }),
  createRoute({
    legacyPath: "/collection/order",
    name: "CollectionOrder",
    viewKey: "collectionOrder",
    code: "collectionOrder",
    title: $t("userCenter.titles.collectionOrder"),
    pageTitle: $t("userCenter.titles.collectionOrder"),
  }),
  createRoute({
    legacyPath: "/collection/package",
    name: "CollectionPackage",
    viewKey: "collectionPackage",
    code: "collectionPackage",
    title: $t("userCenter.titles.collectionPackage"),
    pageTitle: $t("userCenter.titles.collectionPackage"),
  }),
  createRoute({
    legacyPath: "/collection/forecast",
    name: "CollectionForecast",
    viewKey: "collectionForecast",
    code: "collectionForecast",
    title: $t("userCenter.titles.forecast"),
    pageTitle: $t("userCenter.titles.forecast"),
  }),
  createRoute({
    legacyPath: "/collection/newCustomerTask",
    name: "NewCustomerTaskCenter",
    viewKey: "collectionNewCustomerTask",
    code: "NewCustomerTaskCenter",
    title: "新客任务",
    pageTitle: "新客任务",
  }),
  createRoute({
    legacyPath: "/collection/income",
    name: "CollectionIncome",
    viewKey: "collectionIncome",
    code: "collectionIncome",
    title: $t("userCenter.titles.income"),
    pageTitle: $t("userCenter.titles.income"),
  }),
  createRoute({
    legacyPath: "/collection/address",
    name: "CollectionAddress",
    viewKey: "collectionAddress",
    code: "collectionAddress",
    title: $t("userCenter.titles.address"),
    pageTitle: $t("userCenter.titles.address"),
  }),
  createRoute({
    legacyPath: "/collection/invite",
    name: "CollectionInvite",
    viewKey: "collectionInvite",
    code: "collectionInvite",
    title: $t("userCenter.titles.invite"),
    pageTitle: $t("userCenter.titles.invite"),
  }),
  createRoute({
    legacyPath: "/collection/findLogistics",
    name: "FindLogistics",
    viewKey: "collectionFindLogistics",
    code: "FindLogistics",
    title: $t("userCenter.titles.findLogistics"),
    pageTitle: $t("userCenter.titles.findLogistics"),
  }),
  createRoute({
    legacyPath: "/collection/rechargeWallet",
    name: "CollectionRechargeWallet",
    viewKey: "collectionRechargeWallet",
    code: "collectionRechargeWallet",
    title: $t("userCenter.titles.quickRecharge"),
    pageTitle: $t("userCenter.titles.quickRecharge"),
  }),
  createRoute({
    legacyPath: "/collection/recharge",
    name: "CollectionRecharge",
    viewKey: "collectionRecharge",
    code: "collectionRecharge",
    title: $t("userCenter.titles.quickRecharge"),
    pageTitle: $t("userCenter.titles.quickRecharge"),
  }),
  createRoute({
    legacyPath: "/collection/coupons",
    name: "CollectionCoupons",
    viewKey: "collectionCoupons",
    code: "collectionCoupons",
    title: $t("userCenter.titles.coupons"),
    pageTitle: $t("userCenter.titles.coupons"),
  }),
  createRoute({
    legacyPath: "/collection/feedback",
    name: "CollectionFeedback",
    viewKey: "collectionFeedback",
    code: "collectionFeedback",
    title: $t("userCenter.titles.feedback"),
    pageTitle: $t("userCenter.titles.feedback"),
  }),
  createRoute({
    legacyPath: "/collection/points",
    name: "CollectionPoints",
    viewKey: "collectionPoints",
    code: "collectionPoints",
    title: $t("userCenter.titles.points"),
    pageTitle: $t("userCenter.titles.points"),
  }),
  createRoute({
    legacyPath: "/collection/payOrder",
    name: "CollectionPayOrder",
    viewKey: "collectionPayOrder",
    code: "collectionPayOrder",
    title: $t("userCenter.titles.payBill"),
    pageTitle: $t("userCenter.titles.payBill"),
  }),
  createRoute({
    legacyPath: "/collection/declaration",
    name: "CollectionDeclaration",
    viewKey: "collectionDeclaration",
    code: "collectionDeclaration",
    title: $t("userCenter.titles.declaration"),
    pageTitle: $t("userCenter.titles.declaration"),
  }),
  createRoute({
    legacyPath: "/collection/proxy",
    name: "CollectionProxy",
    viewKey: "collectionProxy",
    code: "collectionProxy",
    title: $t("userCenter.titles.proxy"),
    pageTitle: $t("userCenter.titles.proxy"),
  }),
  createRoute({
    legacyPath: "/collection/withdrawCash",
    name: "WithdrawCash",
    viewKey: "collectionWithdrawCash",
    code: "withdrawCash",
    title: $t("userCenter.titles.withdrawCash"),
    pageTitle: $t("userCenter.titles.withdrawCash"),
  }),
  createRoute({
    legacyPath: "/collection/ReturnPackage",
    name: "CollectionReturnPackage",
    viewKey: "collectionReturnPackage",
    title: $t("userCenter.titles.returnPackage"),
    pageTitle: $t("userCenter.titles.returnPackage"),
  }),
];

export const userCenterRouteNameSet = new Set(
  userCenterRouteDefs.map(route => route.name),
);

const migratedLegacyPrefixes = ["/mall", "/collection", "/login"];
const canonicalLegacyPathMap = new Map(
  userCenterRouteDefs.map(route => [route.legacyPath.toLowerCase(), route.legacyPath]),
);

function splitPathAndSuffix(path: string) {
  const match = String(path || "").match(/^([^?#]*)(.*)$/);
  return {
    pathname: match?.[1] || "",
    suffix: match?.[2] || "",
  };
}

function normalizePathname(pathname: string) {
  if (!pathname) {
    return "/";
  }
  return pathname.startsWith("/") ? pathname : `/${pathname}`;
}

function normalizeLocalAbsolutePath(path = "") {
  if (!/^(https?:)?\/\//.test(path)) {
    return path;
  }

  try {
    const base = typeof window !== "undefined" ? window.location.origin : "http://localhost";
    const url = new URL(path, base);
    const currentHost = typeof window !== "undefined" ? window.location.host : "";
    const isCurrentHost = currentHost && url.host === currentHost;
    const isLocalDevHost = ["localhost", "127.0.0.1", "0.0.0.0"].includes(url.hostname);

    if (isCurrentHost || isLocalDevHost) {
      return `${url.pathname}${url.search}${url.hash}`;
    }
  }
  catch {
    return path;
  }

  return path;
}

function matchesPrefix(pathname: string, prefixes: string[]) {
  return prefixes.some(prefix =>
    pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

export function stripUserCenterBase(path = "") {
  if (!path.startsWith(USER_CENTER_BASE_PATH)) {
    return path;
  }
  const result = path.slice(USER_CENTER_BASE_PATH.length);
  return result || "/";
}

export function legacyPathToUserCenterPath(path = "") {
  if (!path) {
    return path;
  }
  const normalizedLocalPath = normalizeLocalAbsolutePath(path);
  if (/^(https?:)?\/\//.test(normalizedLocalPath)) {
    return normalizedLocalPath;
  }
  if (path.startsWith(USER_CENTER_BASE_PATH)) {
    return path;
  }
  if (normalizedLocalPath.startsWith(USER_CENTER_BASE_PATH)) {
    return normalizedLocalPath;
  }
  const { pathname, suffix } = splitPathAndSuffix(normalizedLocalPath);
  const normalizedPathname = normalizePathname(pathname);

  if (
    normalizedPathname.toLowerCase() === "/mall/estimation"
    || normalizedPathname.toLowerCase() === "/collection/estimation"
  ) {
    return `/collection/estimation${suffix}`;
  }

  if (normalizedPathname === "/sub" || normalizedPathname === "/sub/") {
    return `${USER_CENTER_BASE_PATH}${suffix}`;
  }

  const pathWithoutSubPrefix = normalizedPathname.startsWith("/sub/")
    ? normalizePathname(normalizedPathname.slice(4))
    : normalizedPathname;

  if (pathWithoutSubPrefix.toLowerCase() === "/mall/detail1688") {
    const queryPart = suffix.startsWith("?") ? suffix.slice(1).split("#")[0] : "";
    const hashPart = suffix.includes("#") ? suffix.slice(suffix.indexOf("#")) : "";
    const params = new URLSearchParams(queryPart);
    const detailId = params.get("detailId") || params.get("id") || params.get("offerId");

    if (detailId) {
      params.delete("id");
      params.delete("offerId");
      params.set("detailId", detailId);
    }

    const nextQuery = params.toString();
    return `/product${nextQuery ? `?${nextQuery}` : ""}${hashPart}`;
  }

  const canonicalLegacyPath = canonicalLegacyPathMap.get(pathWithoutSubPrefix.toLowerCase())
    || pathWithoutSubPrefix;

  if (matchesPrefix(canonicalLegacyPath, migratedLegacyPrefixes)) {
    return `${USER_CENTER_BASE_PATH}${canonicalLegacyPath}${suffix}`;
  }

  return path;
}

export function normalizeLegacyLocation(to: RouteLocationRaw): RouteLocationRaw {
  if (typeof to === "string") {
    return legacyPathToUserCenterPath(to);
  }

  if (to && typeof to === "object" && "path" in to && typeof to.path === "string") {
    return {
      ...to,
      path: legacyPathToUserCenterPath(to.path),
    };
  }

  return to;
}

export function getUserCenterRouteByViewKey(viewKey = "") {
  return userCenterRouteDefs.find(route => route.viewKey === viewKey);
}

export function getUserCenterRouteByName(name = "") {
  return userCenterRouteDefs.find(route => route.name === name);
}
